import * as React from 'react';

import Tooltip from 'components/Tooltip';

import './reporting-statistic-table.scss';

export type ReportingStatisticTableItem = {
  key: string,
  label: string,
  tooltip?: string,
  value: string
};

type Props = {
  items: Array<ReportingStatisticTableItem>
};

const ReportingStatisticTable = (
  {
    items
  }: Props
): JSX.Element => (
  <div className="reporting-statistic-table">
    {
      items
        .map(item => (
          <div
            className="reporting-statistic-table__metric"
            key={item.key}
          >
            <div className="reporting-statistic-table__metric-value">
              {item.value}
            </div>
            <div className="reporting-statistic-table__metric-name">
              {item.label}
              {
                item.tooltip && (
                  <Tooltip
                    message={item.tooltip}
                    width="long"
                    showQuestionMark
                    classNameWrapper="reporting-statistic-table__tooltip"
                  />
                )
              }
            </div>
          </div>
        ))
      }
  </div>
);

export default ReportingStatisticTable;
